'use client';
import styled from '@emotion/styled';
import {keyframes} from '@emotion/react';

// --- 复用品牌 ---
const APP_NAME = "鸟玻璃®";
const LOGO_URL = "https://cdn.xinmoden.com/images/app/new-logo.webp";

// --- 动效 ---
const float = keyframes`
    0% {
        transform: translateY(0px);
    }
    50% {
        transform: translateY(-10px);
    }
    100% {
        transform: translateY(0px);
    }
`;

const glow = keyframes`
    0% {
        filter: drop-shadow(0 0 10px rgba(96, 165, 250, 0.3));
    }
    50% {
        filter: drop-shadow(0 0 30px rgba(168, 85, 247, 0.6));
    }
    100% {
        filter: drop-shadow(0 0 10px rgba(96, 165, 250, 0.3));
    }
`;

const shimmer = keyframes`
    0% {
        background-position: -200% center;
    }
    100% {
        background-position: 200% center;
    }
`;

// --- 布局 ---
const Wrapper = styled.div`
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: radial-gradient(circle at 20% 20%, #0b0b12, #020617 80%);
    color: #e2e8f0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    overflow: hidden;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        width: 180%;
        height: 180%;
        background: radial-gradient(circle, rgba(168, 85, 247, 0.08), transparent 60%);
        animation: ${float} 14s ease-in-out infinite;
    }
`;

const Content = styled.div`
    text-align: center;
    z-index: 1;
`;

// --- Logo + 品牌 ---
const LogoFrame = styled.div`
    width: 88px;
    height: 88px;
    border-radius: 22px;
    margin: 0 auto 16px;
    padding: 8px;
    background: #fff;
    animation: ${float} 6s ease-in-out infinite;

    img {
        width: 100%;
        height: 100%;
        border-radius: 14px;
        object-fit: contain;
    }
`;

const Brand = styled.div`
    font-size: 14px;
    letter-spacing: 2px;
    color: #64748b;
    margin-bottom: 24px;
`;

// --- 404 主体 ---
const Title = styled.h1`
    font-size: 110px;
    margin: 0;
    letter-spacing: 6px;

    background: linear-gradient(90deg, #60a5fa, #a855f7, #f472b6, #60a5fa);
    background-size: 200% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    animation: ${shimmer} 4s linear infinite, ${glow} 3s ease-in-out infinite;
`;

const Text = styled.p`
    font-size: 18px;
    margin-top: 16px;
    color: #94a3b8;
`;

const SubText = styled.p`
    font-size: 14px;
    margin-top: 8px;
    color: #64748b;
`;

// --- 按钮 ---
const Actions = styled.div`
    margin-top: 28px;
    display: flex;
    gap: 16px;
    justify-content: center;
`;

const Button = styled.button`
    padding: 10px 20px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: linear-gradient(135deg, #60a5fa, #a855f7);
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.25s ease;

    &:hover {
        transform: translateY(-2px) scale(1.04);
        box-shadow: 0 10px 30px rgba(96, 165, 250, 0.3);
    }
`;

const GhostButton = styled.button`
    padding: 10px 20px;
    border-radius: 999px;
    border: 1px solid #222;
    background: transparent;
    color: #94a3b8;
    font-size: 14px;
    cursor: pointer;

    &:hover {
        border-color: #444;
        color: #fff;
    }
`;

export default function NotFoundRender() {
    return (
        <Wrapper>
            <Content>
                <LogoFrame>
                    <img src={LOGO_URL} alt={`${APP_NAME} Logo`}/>
                </LogoFrame>

                <Brand>{APP_NAME}</Brand>

                <Title>404</Title>

                <Text>这个页面，被“变没了” 🎩</Text>
                <SubText>也可能只是链接写错了，或者它正在别的宇宙演出</SubText>

                <Actions>
                    <Button onClick={() => (window.location.href = '/')}>
                        返回首页
                    </Button>
                    <GhostButton onClick={() => history.back()}>
                        返回上一页
                    </GhostButton>
                </Actions>
            </Content>
        </Wrapper>
    );
}
